import Cookies from "js-cookie";

import config from "../Config";

/**
 * Кэширует медиа вопросов (Cache API) с заголовками авторизации.
 * Защищённые URL без публичного доступа могут не открываться в <img> офлайн — это ограничение браузера.
 */
export async function precacheSurveyMediaFromPayload(payload) {
    if (typeof caches === "undefined" || !payload?.questions?.length) return;
    const token = Cookies.get(config.authCookie);
    if (!token) return;

    const urls = new Set();
    for (const q of payload.questions) {
        if (q.picture_filename) {
            const u = config.getMediaUrl(q.picture_filename);
            if (u) urls.add(u);
        }
        if (q.voice_filename) {
            const u = config.getMediaUrl(q.voice_filename);
            if (u) urls.add(u);
        }
    }

    const cache = await caches.open("spiria-media-v1");
    for (const url of urls) {
        try {
            const hit = await cache.match(url);
            if (hit) continue;
            const res = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    apikey: config.apiKey,
                },
            });
            if (res.ok) await cache.put(url, res);
        } catch {
            /* ignore */
        }
    }
}
